import CountriesStore from '../flux/CountriesStore';
export default countryId => {
    let country = CountriesStore.find(countryId);
    return ['Malaysia','Singapore','Hong Kong', 'Macau','Taiwan', 'China', 'Vietnam'].indexOf(country.name) === -1;
}



// WEBPACK FOOTER //
// ./src/utils/shouldShowPrice.js